import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as actions from '../actions/site';
import * as searchActions from '../actions/search';
import { Observable } from 'rxjs';
import { CoordinateList } from '../models/coordinate-list';
import { ListItem } from 'app/modules/core/models/list-item';
import { SearchCriteria } from '../models/search-criteria';





@Component({
  selector: 'app-google-map',
  styles: [],
  template: `
  <div>
    <irar-google-map [farmGps]="farmGps$ | async"
                    [aocGps]="aocGps$ | async"
                    (selectSite)="selectSite($event)"></irar-google-map>
    <div style="margin-top:10px;">
      <img src="../images/FullMap_Optimized.jpg"
        alt="Beltsville Agricultural Research Center Possible Environmental Areas of Concern"
        title="Beltsville Agricultural Research Center Possible Environmental Areas of Concern"
        height="367"
        width="570"
        class="photoborder" />
    </div>
    <p-dialog header="Area of Concern" width="930" [(visible)]="displayDialog">
      <irar-site-details [site]="selectedSite$ | async"
                        (getDocuments)="searchDocuments($event)"
                        [loading]="loading$ | async"></irar-site-details>
    </p-dialog>
  </div>
  `
})

export class GoogleMapContainer {
  farmGps$ : Observable<CoordinateList[]>;
  aocGps$ : Observable<CoordinateList[]>;
  selectedSite$: Observable<ListItem>;
  loading$: Observable<boolean>;
  selectedSiteAbbr: string;
  displayDialog: boolean = false;

  constructor(private store: Store<fromRoot.State>) {
    this.selectedSiteAbbr = '';
    
    this.farmGps$ = this.store.select(fromRoot.getFarmGps);
    this.aocGps$ = this.store.select(fromRoot.getAocGps);
    this.selectedSite$ = this.store.select(fromRoot.getSelectedSite);
    this.loading$ = this.store.select(fromRoot.getSearchLoading);
  }

  selectSite(site: string) {
    this.selectedSiteAbbr = site;
    this.store.dispatch(new actions.SelectSiteAction(site));
    this.displayDialog = true;
  }

  searchDocuments(e: SearchCriteria) {
    this.store.dispatch(new searchActions.SearchDocumentsAction(e));
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/containers/google-map.ts